import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import VueRouter from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue_router.js?vue3';
import VueApollo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue_apollo.js?vue3';
import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import createDefaultClient from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/graphql.js?vue3';
import { convertObjectPropsToCamelCase } from '~/lib/utils/common_utils';
import { rootPath } from '~/lib/utils/path_helpers/routes';
import { resolvers } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/groups/show/graphql/resolvers.js?vue3';
import routes from '/builds/gitlab/gitlab-ee/app/assets/javascripts/groups/show/routes.js?vue3';
import GroupsShowApp from '/builds/gitlab/gitlab-ee/app/assets/javascripts/groups/show/components/app.vue?vue3';

Vue.use(VueRouter);

export const createRouter = () => {
  const router = new VueRouter({
    routes,
    mode: 'history',
    base: rootPath(),
  });

  return router;
};

export const initGroupsShowApp = () => {
  const el = document.getElementById('js-groups-show-app');

  if (!el) return false;

  const {
    dataset: { appData },
  } = el;

  const {
    initialSort,
    fullPath,
    subgroupsAndProjectsEndpoint,
    newSubgroupPath,
    newProjectPath,
    canCreateSubgroups,
    canCreateProjects,
    emptyProjectsIllustration,
  } = convertObjectPropsToCamelCase(JSON.parse(appData));

  const apolloProvider = new VueApollo({
    defaultClient: createDefaultClient(resolvers(subgroupsAndProjectsEndpoint)),
  });

  return initVueApp({
    el,
    router: createRouter(),
    apolloProvider,
    name: 'GroupsShowRoot',
    provide: {
      newSubgroupPath,
      newProjectPath,
      canCreateSubgroups,
      canCreateProjects,
      emptyProjectsIllustration,
    },
    component: GroupsShowApp,
    props: { initialSort, fullPath },
  });
};
